const labels = {
  da: {
    fullTime: 'Fuldtid',
    partTime: 'Deltid',
    filterButtons: {
      vip: 'Videnskabelige og undervisning',
      tap: 'Administrative og tekniske',
      phd: 'Ph.d.-stillinger',
      location: 'Arbejdssted',
      hours: 'Timer pr. uge',
      area: 'Fagområde',
    },
    available: 'ledige stillinger',
    availableSingle: 'ledig stilling',
    on: 'på',
    matches: 'matcher dine valg',
    matchesSingle: 'matcher dine valg',
    none: 'Ingen',
    filter: 'Tilføj filter',
    select: {
      type: 'Vælg jobtype',
      location: 'Vælg by eller landsdel',
      hours: 'Vælg arbejdstid',
      area: 'Vælg fakultet eller enhed',
    },
    areas: {
      ar: 'Kultur, samfund, pædagogik, teologi, sprog, æstetik, uddannelse, kommunikation',
      he: 'Medicin, folkesundhed, odontologi, biomedicin, retsmedicin, idræt, tandpleje, sygepleje',
      nat: 'Biologi, fysik og astronomi, kemi, geologi, matematik, datalogi, molekylærbiologi og nanoscience',
      tech: 'Ingeniørvidenskab, miljø-, agro- og fødevarevidenskab, myndighedsrådgivning',
      bss: 'Erhverv, samfund, jura, psykologi, økonomi, ledelse, forretningsudvikling',
      aias: 'Fri grundforskning og talentudvikling inden for alle fagdiscipliner',
    },
    empty: 'I øjeblikket har vi desværre<br /><strong>ingen ledige stillinger</strong>',
    emptyBtnLink: '//www.au.dk/om/ledige-stillinger/',
    emptyBtnLabel: 'Andre ledige stillinger på Aarhus Universitet',
    noResults: '<p>Øv, vi har desværre ingen ledige stillinger, der matcher dine valg.</p><p>Prøv eventuelt at ændre dine valg.</p>',
    noResultsFaculty: '<p>Øv, vi har desværre ingen ledige stillinger, der matcher dine valg.</p><p>Prøv eventuelt at ændre dine valg eller <span class="avoid-wrap"><a href="//www.au.dk/om/ledige-stillinger/">se ledige stillinger for hele Aarhus Universitet</a>.</span></p>',
    list: {
      deadline: 'Ansøgningsfrist',
      fulltime: 'Fuldtidsstilling',
      parttime: 'Deltid',
      parttimeFull: 'Deltidsstilling',
      hours: 'timer',
      prWeek: 'pr. uge',
      expected: 'Forventet start',
      timelimit: 'Tidsbegrænset',
    },
    locations: {
      aarhus: 'Aarhus',
      cph: 'København',
      herning: 'Herning',
      foulum: 'Foulum, Viborg Kommune',
      roskilde: 'Roskilde',
      jutland: 'Jylland',
      zealand: 'Sjælland, Fyn og øerne',
      outside: 'Udenfor Danmark',
    },
    jobbankLink: '',
    jobbankLinkText: 'Log ind og opret jobagent',
    jobbankHeader: 'Vil du have besked om nye ledige stillinger?',
    jobbankText: 'Opret dig i vores karrierecenter og lav din helt egen jobagent.',
  },
  en: {
    fullTime: 'Full-time',
    partTime: 'Part-time',
    filterButtons: {
      vip: 'Academic and teaching',
      tap: 'Administrative and technical',
      phd: 'PhD positions',
      location: 'Place of work',
      hours: 'Hours per week',
      area: 'Field',
    },
    available: 'vacant positions',
    availableSingle: 'vacant position',
    on: 'at',
    none: 'No',
    matches: 'matches your choices',
    matchesSingle: 'match your choices',
    filter: 'Add filter',
    select: {
      type: 'Select type of job',
      location: 'Select city or region',
      hours: 'Select working hours',
      area: 'Select faculty or unit',
    },
    areas: {
      ar: 'Culture, society, pedagogics, theology, languages, aesthetics, education, communication',
      he: 'Medicine, public health, odontology, biomedicine, forensic medicine, sport science, dental hygiene, nursing',
      nat: 'Biology, physics and astronomy, chemistry, geology, mathematics, computer science, molecular biology and nanoscience',
      tech: 'Engineering, environmental science, agricultural science, food science, public sector consultancy',
      bss: 'Business, society, law, psychology, economics, management, business development',
      aias: 'Independent basic research and talent development within all fields',
    },
    empty: 'At the moment we have <br /><strong>no vacant positions</strong>',
    emptyBtnLink: '//international.au.dk/about/profile/vacant-positions/',
    emptyBtnLabel: 'Other vacant positions at Aarhus University',
    noResults: '<p>Sorry, we have no vacant positions that match your choices.</p><p>Please, try chancing your choices.</p>',
    noResultsFaculty: '<p>Sorry, we have no vacant positions that match your choices.</p><p>Please, try chancing your choices or go to <span class="avoid-wrap"><a href="https://international.au.dk/about/profile/vacant-positions/">all vacant positions at Aarhus University</a>.</span></p>',
    list: {
      deadline: 'Deadline',
      fulltime: 'Full-time position',
      parttime: 'Part-time',
      parttimeFull: 'Part-time position',
      hours: 'hours',
      prWeek: 'per week',
      expected: 'Expected start',
      timelimit: 'Fixed term',
    },
    locations: {
      aarhus: 'Aarhus',
      cph: 'Copenhagen',
      herning: 'Herning',
      foulum: 'Foulum, Viborg Municipality',
      roskilde: 'Roskilde',
      jutland: 'Jutland (Western Denmark)',
      zealand: 'Zealand, Funen and Islands (Eastern Denmark)',
      outside: 'Outside Denmark',
    },
    jobbankLink: '',
    jobbankLinkText: 'Log in and create job agent',
    jobbankHeader: 'Want to be notified of new vacancies?',
    jobbankText: 'Join our Career Centre and create your very own job agent.',
  },
};

export default labels;
